import { assessorSchema } from "@/schema/console/assessors/Assessor";
import { z } from "zod";

export const assessorUpdateSchema = assessorSchema.omit({ id: true });

export type AssessorUpdate = z.infer<typeof assessorUpdateSchema>;
